import { render, staticRenderFns } from "./ClientDictionary.vue?vue&type=template&id=0d8cb1dc&scoped=true&"
import script from "./ClientDictionary.vue?vue&type=script&lang=js&"
export * from "./ClientDictionary.vue?vue&type=script&lang=js&"
import style0 from "./ClientDictionary.vue?vue&type=style&index=0&id=0d8cb1dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8cb1dc",
  null
  
)

export default component.exports